import React, { createContext, useContext, useState, useEffect } from "react";
import { getAllIcons } from "../api";

// Create the context
const IconContext = createContext();

// Create a provider component
export const IconProvider = ({ children }) => {
  const [icons, setIcons] = useState([]);
  const [iconsMap, setIconsMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchIcons = async () => {
    if (isLoaded) return; // Don't fetch if already loaded
    
    setIsLoading(true);
    try {
      const response = await getAllIcons();
      setIcons(response.data);
      const iconsMap = response.data.reduce((acc, icon) => {
        acc[icon.name] = icon.url;
        return acc;
      }, {});
      setIconsMap(iconsMap);
      setIsLoaded(true);
    } catch (error) {
      console.error("Error fetching icons:", error);
      // If it's an authentication error (401), retry after a delay
      if (error.response && error.response.status === 401) {
        console.log("Authentication error, retrying icon loading in 2 seconds...");
        setTimeout(() => {
          if (!isLoaded) {
            fetchIcons();
          }
        }, 2000);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const refreshIcons = async () => {
    setIsLoaded(false);
    await fetchIcons();
  };

  // Auto-load icons when the provider mounts
  useEffect(() => {
    fetchIcons();
  }, []);

  return (
    <IconContext.Provider value={{ 
      icons, 
      iconsMap, 
      isLoading, 
      isLoaded,
      fetchIcons,
      refreshIcons 
    }}>
      {children}
    </IconContext.Provider>
  );
};

// Custom hook to use the IconContext
export const useIcons = () => useContext(IconContext);
